import React from "react";
import { ClearingPartnerDetailsContainer } from "../../../containers";

const ClearingPartnerDetails = (props) => {
  return <ClearingPartnerDetailsContainer {...props} />;
};

export default ClearingPartnerDetails;
